export const chevronIconCSS = {
  marginLeft: '-8px',
  marginRight: '-8px',
  // opacity 51% matches the N80 when on white, and will be nice for other themes too
  opacity: 0.51
};